import type { FuseType } from "../types";

/**
 * Only spellings that name exactly one family: `ami` is Littelfuse's MIDI®/AMI®,
 * `ato` their ATO®, the same blade fuse as ATC. Deliberately absent: bare "blade"
 * (ATC, MAXI and MIDI are all blades) and anything carrying a number.
 */
const MARKER_ALIASES: Record<string, FuseType> = {
  mrbf: "MRBF",
  "class t": "ClassT",
  classt: "ClassT",
  "t class": "ClassT",
  mega: "MEGA",
  midi: "MIDI",
  ami: "MIDI",
  maxi: "MAXI",
  anl: "ANL",
  atc: "ATC",
  ato: "ATC",
  "atc ato": "ATC",
  "ato atc": "ATC",
  nh: "NH",
  gpv: "gPV",
  mdl: "MDL",
};

const NOISE = new Set([
  "fuse",
  "fuses",
  "terminal",
  "holder",
  "block",
  "style",
  "type",
  "inline",
  "blade",
  "bolted",
  "the",
  "a",
  "an",
]);

/** `null` means "leave the marker as free text" — never a default family. */
export function parseFuseMarker(marker: string | null | undefined): FuseType | null {
  if (!marker) return null;
  const words = marker
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim()
    .split(" ")
    .filter((word) => word.length > 0 && !NOISE.has(word));
  if (words.length === 0) return null;
  return MARKER_ALIASES[words.join(" ")] ?? null;
}
